import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    IconButton,
    TextField,
    InputAdornment
} from '@mui/material';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import AddIcon from '@mui/icons-material/Add';

import ExpandedTextField from '../display/ExpandedTextField';
import FullDataGrid from '../datagrid/FullDataGrid';

    // Datagrid column Definition for Metadata in DB
    const customMetaColumns = [
        {
            field: 'metadataName',
            headerName: 'Metadata Name',
            flex: 1,
        },
        {
            field: 'customString',
            headerName: 'Custom String',
            flex: 1,
            editable: true
        },
    ]

export default function CustomAvidColPopover(props){

    const { setConfigRows, configRef, customRows, setCustomRows, addCustomRow } = props

    const [konsolColName, setKonsolColName] = useState('')
    const [avidColName, setAvidColName] = useState('')

    const customMetaRef = useGridApiRef() 


    const saveChanges = () => {
        // Add the rows to the state   
        addCustomRow(konsolColName, avidColName)
    }

    return (
        <Box
            width={'600px'}
            >
            <Box
                height={'auto'}
                overflow={'auto'}
            >
                <Box
                    display={'flex'}
                    justifyContent={'center'}
                    p={'10px'}
                >
                    <ExpandedTextField
                        label="Konsol Field Name"
                        value={konsolColName}
                        onChange={(e) => setKonsolColName(e.target.value)}
                    />
                    <ExpandedTextField
                        label="Avid Field Name"
                        value={avidColName}
                        onChange={(e) => setAvidColName(e.target.value)}                  
                    />
                </Box>
        </Box>
            <Box
                pt='10px'
                display={'flex'}
                justifyContent={'flex-end'}
            >
                <Button
                    sx={{ color: 'rgba(255, 255, 255, 1)' }}
                    onClick={saveChanges}
                >
                    Save
                </Button>
            </Box>
        </Box>
    )
}